import { render, staticRenderFns } from "./CardTarjaEnqueteSelecaoSportvWithQRCode.vue?vue&type=template&id=f9b7bd8a&scoped=true"
import script from "./CardTarjaEnqueteSelecaoSportvWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSelecaoSportvWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSelecaoSportvWithQRCode.vue?vue&type=style&index=0&id=f9b7bd8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b7bd8a",
  null
  
)

export default component.exports